import { Injectable, Inject } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class LikeService {
  // The item whose likes just changed, after the like / unlike request returns (its `likes` is already updated).
  readonly changed = new Subject<any>();

  constructor(@Inject('ServiceByType') private ServiceByType: any) {}

  like(type: string, id: number): Promise<any> {
    return this.ServiceByType.get(type).like(id);
  }

  unlike(type: string, id: number): Promise<any> {
    return this.ServiceByType.get(type).unlike(id);
  }

  likedUsers(item: { type: string; id: number }, parameters: any): Promise<any> {
    return this.ServiceByType.get(item.type).likedUsers(item.id, parameters);
  }
}
